export default String.raw`
.popupBanner {
    background-color: transparent !important;
    width: fit-content !important;
    margin: auto !important;

    &__body {
        position: relative;
        display: grid;
        grid-template-areas: 
                    "i h"
                    "i c";
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto;
        gap: 24px;
        width: 693px;
        height: 418px;
        border-radius: 12px;
        padding-right: 12px;
        background-color: $bgColor;
        overflow: hidden;

        &-close {
            position: absolute;
            right: 24px;
            top: 32px;

            svg {
                width: 24px;
                height: 24px;
                fill: $bgColorFont;
                cursor: pointer;
            }
        }

        &-header {
            grid-area: h;
            padding-top: 32px;
            padding-right: 12px;
            
            h2 {
                width: 295px;
                text-overflow: ellipsis;
                overflow: hidden;
                padding-right: 5px;
            }
        }

        &-image {
            grid-area: i;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;

            a {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                border-radius: 12px 0 0 12px;

                &:focus-visible {
                    outline-offset: -2px !important;
                }
            }

            img {
                width: 100%;
            }
        }

        &-content {
            grid-area: c;
            min-height: 202px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 24px;
            overflow-y: auto;
            padding-right: 12px;

            p {
                @include body-2-regular;
            }

            &:last-child {
                margin-bottom: 32px;
            }
            a {
                margin: 4px;
            }

            &-close {
                display: none ;

                button {
                    height: 40px;
                    width: 100%;
                    padding: 8px 32px;
                    justify-content: center;
                    margin: 4px;
                    
                    &:focus-visible {
                        outline: none !important;
                        span {
                            outline-style: solid !important;
                            outline-color: $focusVisibleColor !important;
                            outline-width: 1px !important;
                            outline-offset: 2px !important;
                        }
                    }
                }
            }
        }
    }
}
`